import script from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"

import "./QuillEditor.vue?vue&type=style&index=0&id=a9d03d7e&lang=scss"

export default script